import { createContext, useContext, useEffect, useState } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { auth, db, storage } from '../firebase-config';
import { doc, getDoc, getDocs, setDoc, collection } from 'firebase/firestore';
import {
  ref,
  uploadBytesResumable,
  uploadString,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';

const UserContext = createContext();
const currentYearDataBase = '2023';

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  const getClient = () => {
    const dataValueClient = getDoc(doc(db, currentYearDataBase, user.uid));
    return dataValueClient;
  };

  const getUserList = ({ currentYearAdmin }) => {
    const userList = getDocs(collection(db, currentYearAdmin));
    return userList;
  };

  const updateClient = ({ clientData }) => {
    setDoc(doc(db, currentYearDataBase, user.uid), clientData);
    return clientData;
  };

  const updateClientByAdmin = (idToUploadClient, { clientDataByAdmin }) => {
    setDoc(doc(db, currentYearDataBase, idToUploadClient), clientDataByAdmin);
    return clientDataByAdmin;
  };
  const updateClientByAdminNewYear = (
    idToUploadClient,
    { clientDataByAdminNewYear },
  ) => {
    setDoc(doc(db, '2023', idToUploadClient), clientDataByAdminNewYear);
    return clientDataByAdminNewYear;
  };

  const createUser = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const uploadFiles = (storagePath, fileData) => {
    const storageRef = ref(storage, storagePath);
    const uploadFiles = uploadBytesResumable(storageRef, fileData);
    return uploadFiles;
  };

  const uploadStringFiles = (storagePath, fileData) => {
    const storageRef = ref(storage, storagePath);
    const uploadFiles = uploadString(storageRef, fileData);
    return uploadFiles;
  };

  const getUrlDownloadFile = (insertImages) => {
    return getDownloadURL(insertImages);
  };

  const openFileStorage = (fileNamePath) => {
    const urlOpen = getDownloadURL(ref(storage, fileNamePath));
    return urlOpen;
  };

  const deleteFiletoStorage = (FilePath) => {
    const storageRef = ref(storage, FilePath);
    return deleteObject(storageRef);
  };

  const resetPassword = (email) => {
    return sendPasswordResetEmail(auth, email);
  };

  const logout = () => {
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        resetPassword,
        signIn,
        createUser,
        user,
        logout,
        updateClient,
        updateClientByAdmin,
        updateClientByAdminNewYear,
        getClient,
        getUserList,
        uploadFiles,
        uploadStringFiles,
        getUrlDownloadFile,
        deleteFiletoStorage,
        openFileStorage,
      }}
    >
      {!loading && children}
    </UserContext.Provider>
  );
};
export const UserAuthContext = () => {
  return useContext(UserContext);
};
